import type { MenuList } from '../../interface/layout/menu.interface';
import type { FC } from 'react';
import { Menu, Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserItem } from '../../stores/user.store';
import { CustomIcon } from './customIcon';
import { resetTagState } from '../../stores/tags-view.store';

interface MenuProps {
  menuList: MenuList;
  openKey?: string;
  onChangeOpenKey: (key?: string) => void;
  selectedKey: string;
  onChangeSelectedKey: (key: string) => void;
}

const MenuComponent: FC<MenuProps> = ({
  menuList,
  openKey,
  onChangeOpenKey,
  selectedKey,
  onChangeSelectedKey,
}) => {
  const { device, locale } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Menu title rendering with icon and badge
  const getTitle = (menu: MenuList[0] | any) => (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {menu.icon && <CustomIcon type={menu.icon} />}
        <span>{menu.label[locale]}</span>
      </span>

      {menu.badge && (
        <Badge
          size="default"
          count={menu.badge === 'dot' ? 0 : menu.badge}
          className="blue-badge"
          overflowCount={99}
        />
      )}
    </span>
  );

  const onMenuClick = (path: string) => {
    onChangeSelectedKey(path);
    dispatch(resetTagState(path));
    navigate(path);

    if (device !== 'DESKTOP') {
      dispatch(setUserItem({ collapsed: true }));
    }
  };

  const onOpenChange = (keys: string[]) => {
    const key = keys.pop();
    onChangeOpenKey(key);
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      openKeys={openKey ? [openKey] : []}
      onOpenChange={onOpenChange}
      onSelect={(k: any) => onMenuClick(k.key)}
      className="layout-page-sider-menu text-2"
      items={menuList
        .filter((menu: any) => menu.config !== false)
        .map((menu: any) => {
          if (menu.children && menu.children.length > 0) {
            return {
              key: menu.code,
              label: getTitle(menu),
              children: menu.children
                .filter((child: any) => child.config !== false)
                .map((child: any) => {
                  // Badge element for child
                  const badgeElement =
                    child.badge === 'dot' ? (
                      <Badge dot size="default" className="blue-badge" />
                    ) : child.badge && child.badge > 0 ? (
                      <Badge
                        count={child.badge}
                        size="default"
                        overflowCount={99}
                        className="blue-badge"
                      />
                    ) : null;

                  return {
                    key: child.path, // path string ekanligiga ishonch hosil qiling
                    label: (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <span>{child.label[locale]}</span>
                        {badgeElement}
                      </div>
                    ),
                  };
                }),
            };
          } else {
            return {
              key: menu.path,
              label: getTitle(menu),
            };
          }
        })}
    />
  );
};

export default MenuComponent;
